import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_PUBLIC_PATH || '/',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('./views/Home'),
      redirect: '/projects'
    },

    {
      path: '/projects',
      name: 'Projects',
      component: () => import('./views/Projects')
    },

    {
      path: '/projects/:id',
      redirect: '/projects/:id/create',
      name: 'Project',
      component: () => import('./views/project/Project'),

      children: [
        {
          path: 'create',
          name: 'Create',
          component: () => import('./views/project/ProjectCreate')
        },
        {
          path: 'create/:styleId/',
          name: 'ProjectCreateStyle',
          component: () => import('./views/project/ProjectCreateStyle')
        },
        {
          path: 'present',
          name: 'Present',
          component: () => import('./views/project/ProjectPresent')
        },
        {
          path: 'boards',
          name: 'AllBoards',
          component: () => import('./views/project/AllBoards')
        },
        {
          path: 'feedback',
          name: 'Feedback',
          component: () => import('./views/project/ProjectFeedback')
        },
        {
          path: 'export/boards',
          name: 'ExportBoards',
          component: () => import('./views/project/ExportBoards')
        },
        {
          path: 'export/styles',
          name: 'ExportStyles',
          component: () => import('./views/project/ExportStyles')
        }
      ]
    },

    {
      path: '/collection',
      name: 'Collection',
      component: () => import('./views/Collection')
    },
    {
      path: '/export/collection',
      name: 'ExportCollection',
      component: () => import('./views/ExportCollection')
    },

    /*
    This route is used to share with the user as a link
    to serve as a reference for all FAQs
    */
    {
      path: '/faq',
      name: 'FAQ',
      component: () => import('./views/FAQ')
    },

    /*
    This route is used to mount custom components
    and have a developers reference to them
    */
    {
      path: '/ds',
      name: 'DesignSystem',
      component: () => import('./views/DS')
    },

    /*
    This route path is to handle the 404 Page Not Found status code
    */
    {
      path: '*',
      redirect: '/error-404'
    },
    {
      path: '/error-404',
      component: () => import('./views/error/404')
    }
  ]
})

/**
 * @param {object}   to
 * @param {object}   from
 * @param {Function} next
 */
router.beforeResolve((to, from, next) => {
  router.previousRoute = from
  next()
})

export default router
